import { render, staticRenderFns } from "./CbsWidgetHabitCoach.vue?vue&type=template&id=d8840786&scoped=true"
import script from "./CbsWidgetHabitCoach.vue?vue&type=script&lang=js"
export * from "./CbsWidgetHabitCoach.vue?vue&type=script&lang=js"
import style0 from "./habits/habits.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CbsWidgetHabitCoach.vue?vue&type=style&index=1&id=d8840786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8840786",
  null
  
)

export default component.exports